// src/pages/post/DeletePost.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../../context/userContext';
import axios from 'axios';
import { FaTrashAlt, FaSpinner } from 'react-icons/fa';

const DeletePost = ({ postId: id }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const { currentUser } = useContext(UserContext);
  const token = currentUser?.token;

  // Redirect to login page for any user who isn't logged in
  useEffect(() => {
    if(!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const showDeleteConfirmation = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  const removePost = async () => {
    setIsLoading(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/posts/${id}`, 
        {
          withCredentials: true, 
          headers: {Authorization: `Bearer ${token}`}
        }
      );
      
      if(response.status === 200) {
        if(location.pathname === `/myposts/${currentUser.id}`) {
          navigate(0); // Refresh the current page
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      console.log("Couldn't delete post:", error);
      // Show an error message to the user
    } finally {
      setIsLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      <button 
        onClick={showDeleteConfirmation}
        className="inline-flex items-center px-3 py-1 bg-red text-white text-sm rounded-md hover:bg-opacity-90 transition-colors"
      >
        <FaTrashAlt className="mr-1" size={12} />
        Delete
      </button>

      {/* Delete confirmation modal */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Confirm Delete</h3>
            <p className="text-gray-500 mb-6">
              Are you sure you want to delete this post? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                onClick={removePost}
                className="px-4 py-2 bg-red text-white rounded-md hover:bg-opacity-90 transition-colors flex items-center"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <FaSpinner className="animate-spin mr-2" />
                    Deleting...
                  </>
                ) : (
                  'Delete Post'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeletePost;